import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TimeInput.html?raw';
import lang from 'dojo/_base/lang';
import _LabelInputBase from '../_LabelInputBase/_LabelInputBase';

import docu from './TimeInputDocumentation.html?raw';
import { AccessibilityLabelsHelper } from "../../../more/Helpers";


class TimeInput extends compose(_LabelInputBase) {
    templateString: any = template;

    protected inputNode: HTMLInputElement;
    protected _value : Date;
    protected minTime: string = "00:00";
    protected maxTime: string = "24:00";
    protected old_stringValue: string;
    protected highlightOnEmptyValue: boolean = false;
    protected _manualHighlightOverride: boolean = false;
    validationMsgNodeContainer = "errorMsgNode";
   

    focus() {
        this.inputNode.focus();
    }
    _onKeyUp_Inputnode(evt: KeyboardEvent): void {

        if (this.inputNode.value.length == 5 || evt.key == "Enter") {
                this._onChange_InputNode();
        }

        this.emit("keyUpTimeInput", evt);
    }

    private _onChange_InputNode(evt?: Event): void {
        let randomDate: Date, min, hours;

        if (this.inputNode.value) {
            min = Number(this.inputNode.value.slice(-2));
            hours = Number(this.inputNode.value.slice(0, 2));
            randomDate = new Date();
            randomDate.setHours(hours);
            randomDate.setMinutes(min);
            randomDate.setSeconds(0, 0);
        }
        this.setValue(randomDate); // emits "valueChange" in setInputValue
    }

    _setReadonlyStyle() {
        if (this.isReadonly === true) {
            this.UiModder.domAttr.set(this.inputNode, "disabled", "");
        } else {
            this.UiModder.domAttr.remove(this.inputNode, "disabled");
        }
    }
    /**
     *  newValue darf Date, string (gültig um daraus ein Date zu erstellen) oder null sein.
     * @param newValue
     * @param suppressChangeEvent
     */
    setValue(newValue: any, suppressChangeEvent: boolean = false): void {

        if (this._value) {
            this.old_stringValue = this.timeInput_DateToString(this._value);
        }
        
        if (Object.prototype.toString.call(newValue) === "[object Date]" && !isNaN(newValue.getFullYear())) {
            this._value = newValue;
        } else if (typeof newValue == "string") {

            let shouldBeDate = new Date(newValue);

            if (shouldBeDate && Object.prototype.toString.call(shouldBeDate) === "[object Date]") {
                if (!isNaN(shouldBeDate.getFullYear())) {
                    this._value = shouldBeDate;
                } else {
                    console.warn("Invalid Date_String Format! " + newValue)
                }
            } else {
                console.warn("Invalid Date_String Format! " + newValue)
            }
        } else if (!newValue) {
            this._value = null
        }

        this.setInputValue(suppressChangeEvent); // emits "valueChange"

    }

    protected setInputValue(suppressChangeEvent: boolean = false): void {
        let newInputnodeValue: string;

        if (this._value) {
            let hours = ("0" + this._value.getHours()).slice(-2); // HH
            let min = ("0" + this._value.getMinutes()).slice(-2);  // mm
            newInputnodeValue = hours + ":" + min;
        }

        this.inputNode.value = newInputnodeValue ? newInputnodeValue : null;

        this.validateInput();


        if (this.old_stringValue === newInputnodeValue) {
        } else if (suppressChangeEvent == false) {
            this.__delayValueChangeEmit();
        }

    }

    // Set max and min time values

    setMaxTime(maxTime: string): void {
        this.maxTime = maxTime;
    }

    getMaxTime(): string {
        return this.maxTime;
    }

    setMinTime(minTime: string): void {
        this.minTime = minTime;
    }

    getMinTime(): string {
        return this.minTime;
    }
    // Time Validation to call on Submit

    protected customValidation(): boolean {
        let dateValue = this.getValue();

        if (this.isMandatory == false) {
            return true;
        } else {
            if (dateValue == null) return false;
        }

        if (dateValue != null && this.minTime != null && this.maxTime != null) {
            if (this.minTime.length >= 4 && this.maxTime.length >= 4) {
                let minDate = new Date(this.getValue().getTime());
                minDate.setHours(parseInt(this.minTime.split(":")[0]));
                minDate.setMinutes(parseInt(this.minTime.split(":")[1]));

                let maxDate = new Date(this.getValue().getTime());
                maxDate.setHours(parseInt(this.maxTime.split(":")[0]));
                maxDate.setMinutes(parseInt(this.maxTime.split(":")[1]));

                if (dateValue >= minDate.getTime() && dateValue <= maxDate.getTime()) {
                    return true;
                } else {
                    return false;
                }
            }
        }

        return true;
    }

    timeInput_DateToString(randomDate: Date): string {
        let hours = ("0" + randomDate.getHours()).slice(-2); // HH
        let min = ("0" + randomDate.getMinutes()).slice(-2);  // mm
        //HH:mm
        let timeString = hours + ":" + min
        return timeString;
    }

    forceHighlight(bHighlight: boolean) {
        this._manualHighlightOverride = bHighlight === true;
        this._setValidationResultStyle();
    }

    protected _setValidationResultStyle(): void {
        super._setValidationResultStyle.apply(this, arguments as any);

        var bHighlight = false;
        if (this._manualHighlightOverride != true) {
            bHighlight = this.highlightOnEmptyValue == true && (this.getValue() == null || this.getValue() == "");
        } else {
            bHighlight = this._manualHighlightOverride;
            
        } 

        if (bHighlight) {
            this.UiModder.domClass.add(this.labelNode, "w3-text-red");
            this.UiModder.domClass.add(this.inputNode, "w3-border-red w3-pale-red");
        } else {
            this.UiModder.domClass.remove(this.labelNode, "w3-text-red");
            this.UiModder.domClass.remove(this.inputNode, "w3-border-red w3-pale-red");
        }
    }

  

    // Doku
    getDocumentationContent(): string {
        return docu;
    }

    // dojo

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.domNode.addEventListener("click", lang.hitch(this, function (evt) { evt.stopPropagation() }));

        AccessibilityLabelsHelper.LabelForInputBind(this.id, this.inputNode, "timeInput", this.labelNode);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(TimeInput);